function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { forwardRef, useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { getBaseIndent, getGutterWidth } from "../../theme/selectors";
import Col from "./Col";
import { addFlexStyles, addRowPropStyle, useMediaQuery } from "./utils/styles";
export var rowProps = ['reverse', 'start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between', 'first', 'last', 'fluid', 'grow', 'column'];
var addFluidStyle = addRowPropStyle('fluid', "\n  & > ".concat(Col, ":first-child {\n    padding-left: 0;\n  }\n\n  & > ").concat(Col, ":last-child {\n    padding-right: 0;\n  }\n  "));
var RowStyled = styled(function (_ref) {
  var reverse = _ref.reverse,
      start = _ref.start,
      center = _ref.center,
      end = _ref.end,
      top = _ref.top,
      middle = _ref.middle,
      bottom = _ref.bottom,
      around = _ref.around,
      between = _ref.between,
      first = _ref.first,
      last = _ref.last,
      fluid = _ref.fluid,
      grow = _ref.grow,
      column = _ref.column,
      mediaQuery = _ref.mediaQuery,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["reverse", "start", "center", "end", "top", "middle", "bottom", "around", "between", "first", "last", "fluid", "grow", "column", "mediaQuery", "theme"]);

  return React.createElement("div", otherProps);
}).withConfig({
  displayName: "Row__RowStyled",
  componentId: "sc-1deeeyj-0"
})(["box-sizing:border-box;display:flex;flex:0 1 auto;flex-direction:row;flex-wrap:wrap;", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  var rowMargin = "-".concat(getBaseIndent(theme) * getGutterWidth(theme), "px");
  return css(["margin-right:", ";margin-left:", ";"], rowMargin, rowMargin);
}, addFlexStyles, addFluidStyle);
var Row = React.memo(forwardRef(function (props, ref) {
  var theme = useContext(ThemeContext);
  var children = props.children;
  var mediaQuery = useMediaQuery(theme);
  return React.createElement(RowStyled, _objectSpread({}, props, {
    mediaQuery: mediaQuery,
    ref: ref
  }), children);
}));
Row.displayName = 'Row';
export default Row;